import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/login/auth.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
    selector: 'app-header-profile',
    templateUrl: './header-profile.component.html',
    styleUrls: ['./header-profile.component.scss'],
    standalone: false
})
export class HeaderProfileComponent implements OnInit {

  @Input() dataUser: any;

  constructor(
    config: NgbModalConfig, 
    private modalService: NgbModal,
    private _users: UsersService,
    public authService: AuthService
    ) { }

  ngOnInit() {
    // this._users.getUserSession().subscribe(resp => {
    //   this.user = resp['result'];
    // })
  }

  editProfile(event, content) {
    event.preventDefault();

    this.modalService.open(content);
  }

  saveUser() {
    this.modalService.dismissAll();
  }

}
